import React, { useState } from 'react'
import { UnitSelection } from './UnitSelection'
import {
  getStationsNameMap,
  getUtilityNameMap,
  getStationUtilityMap,
  // getUserRoleType,
} from 'core/selectors'
import { connect } from 'react-redux'
import R from 'ramda'
import { Button, Tag } from 'antd'
const StationSelectionBar = ({
  stationNameMap,
  utilityStationMap,
  utilityNameMap,
  disabled,
  hideSelectedUnits = false,
  // roleType = [],
  avaliableStations,
  ...props
}) => {
  const [showSelection, setShowSelection] = useState(
    props.showSelection || false
  )
  const [selectedStation, setSelectedStation] = useState(props.station || [])

  // const station = R.compose(
  //   R.sortBy(a => (a.unitName ? a.unitName.toLowerCase() : 1)),
  //   R.flatten,
  //   R.map(([utility, stations]) => {
  //     return stations.map(s => ({ unitId: s, unitName: stationNameMap[s], utility }))
  //   }),
  //   R.toPairs
  // )(utilityStationMap)

  const station = avaliableStations
    ? avaliableStations.map(s => ({
        unitId: s,
        utility: s,
        unitName: stationNameMap[s],
      }))
    : R.compose(
        R.map(s => ({ unitId: s, utility: s, unitName: stationNameMap[s] }))
      )(Object.keys(utilityStationMap))

  const confirm = stations => {
    setShowSelection(false)
    setSelectedStation(stations)
    props.selectedStation && props.selectedStation(stations)
    props.setData && props.setData()
  }

  //  if (!roleType.includes('STATION')) return <div>you don't have permission for Stations</div>

  if (props.showSelection || showSelection)
    return (
      <div
        style={{
          paddingLeft: '16px',
          paddingRight: '16px',
          backgroundColor: 'white',
          marginBottom: '10px',
        }}
      >
        <UnitSelection
          onConfirm={confirm}
          units={station}
          station={station}
          close={() => setShowSelection(false)}
          selectedUnits={selectedStation}
          setSelectedUnits={setSelectedStation}
          utilityNameMap={utilityNameMap}
          // checked={selectedStation}
          // setCheckedItems={data => setSelectedStation(data)}
          itemToKey={d => d.unitId + d.utility}
          itemToLabel={d => d.unitId + '-' + (d.unitName || d.unitId)}
          visibleToggleGroup={false}
          visibleToggleUnitType={false}
          placeholder="Filter for Station"
          visibleUtility={false}
          {...props}
        />
      </div>
    )

  return (
    <div
      style={{
        padding: '10px',
        display: 'flex',
        alignItems: 'center',
        backgroundColor: 'white',
        marginBottom: '10px',
        ...props.style,
      }}
    >
      <Button
        disabled={disabled}
        style={{ marginRight: '5px' }}
        onClick={() => setShowSelection(true)}
      >
        Select Station
      </Button>
      {!hideSelectedUnits && (
        <div style={{ display: 'flex', overflow: 'hidden' }}>
          {selectedStation.map(u => (
            <Tag
              closable={!disabled}
              color="blue"
              // onClose={() => removeUnit(u)}
              // closable
              key={u.unitId}
            >
              {u.unitName}
            </Tag>
          ))}
        </div>
      )}
    </div>
  )
}

const mapStateToProps = state => ({
  utilityNameMap: getUtilityNameMap(state),
  stationNameMap: getStationsNameMap(state),
  utilityStationMap: getStationUtilityMap(state),
  // roleType: getUserRoleType(state),
})

const mapDispatchToProps = () => ({})

export default connect(mapStateToProps, mapDispatchToProps)(StationSelectionBar)
